import * as Yup from 'yup';

export default Yup.object().shape({
  observation: Yup.string().trim().required('Escreva um comentário'),
});
